import { getUsers } from "@/services";

/**
 * State of the module
 */
const state = {
  users: [],
};

/**
 * Mutations constant
 */
const SET_USERS = "SET_USERS";

/**
 * Mutations
 */
const mutations = {
  [SET_USERS](state, data) {
    state.users = data;
  },
};

/**
 * Module actions
 */
const actions = {
  /**
   * Fetches list of the users
   */
  async getUsers({ commit }, params = {}) {
    try {
      let { data } = await getUsers(params);
      data = data ?? [];

      commit(SET_USERS, data);
    } catch (error) {
      return Promise.reject(error);
    }
  },
};

/**
 * Module getters
 */
const getters = {
  users({ users }) {
    return users;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};
